import type { ReactElement } from 'react';

import './loading.scss';

export const PdsLoading = (): ReactElement => {
  return (
    <div className="co-flex co-gap-2 co-animation-delay">
      <div
        className={`
                        co-animate-loader-bounce
                        co-bg-pds-primary-100
                        co-w-small-px
                        co-h-small-px
                        co-rounded-full`}
      />
      <div
        className={`
                        co-animate-loader-bounce
                        co-bg-pds-primary-200
                        co-w-small-px
                        co-h-small-px
                        co-rounded-full`}
      />
      <div
        className={`
                        co-animate-loader-bounce
                        co-bg-pds-primary-300
                        co-w-small-px
                        co-h-small-px
                        co-rounded-full`}
      />
    </div>
  );
};
